import $ from 'jquery'

const avantageWidget = $('.avantage-widget'),
    avantageItem = avantageWidget.find('.slider-3col__item--container')

avantageItem.each(function(){
  const item = $(this),
    btnRotate = item.find('.btn-rotate')

  btnRotate.on('click', function(){
    item.toggleClass('active')
  })
})
